import { saveInlineEditing } from "@/lib/inline-editor/inline-editor";
import { saveBrandSettings } from "@/lib/singularity/brand/settings";
import { saveToWordPressWithErrorsLoggedToUiStore } from "@/lib/wordpress/save";
import { uiStore } from "@/store/store";

const CONSOLE_LOG = false;
const AUTOSAVE_INTERVAL = 1000;
let AUTOSAVE_SERVICE_ALREADY_STARTED = false;

function log(...message: any[]) {
  if (CONSOLE_LOG) {
    console.log(...message);
  }
}

function areUnsavedChangesPresent() {
  return uiStore.unsavedChangesPresent;
}

async function maybeDoAutosave() {
  if (!uiStore.isSingularityMode) {
    return; // they could have started in singularity mode, but then switched to normal mode
  }

  if (uiStore.saveInProgress) {
    log("Save in progress, skipping autosave.");
    return;
  }

  if (areUnsavedChangesPresent()) {
    log("Unsaved changes detected, performing autosave.");

    if (uiStore.inlineEditingContext?.elementId) {
      log("Inline editing context detected, triggering inline editor save.");
      await saveInlineEditing(uiStore.inlineEditingContext.elementId);
    }

    await Promise.all([
      saveToWordPressWithErrorsLoggedToUiStore(),
      saveBrandSettings()
    ]);
  } else {
    log("No unsaved changes present, skipping autosave.");
  }
}

export function startAutosaveService() {
  if (AUTOSAVE_SERVICE_ALREADY_STARTED) {
    log("Autosave service already started, skipping initialization.");
    return;
  }
  setInterval(maybeDoAutosave, AUTOSAVE_INTERVAL);
  AUTOSAVE_SERVICE_ALREADY_STARTED = true;
  log("Autosave service started with interval:", AUTOSAVE_INTERVAL);
}
